import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../lib/api';
import { date, eur } from '../lib/format';
import { ErrorBox, Field, Loading, useAction, useLoad } from '../components/ui';

/** Aprobación desde el enlace del correo (sin iniciar sesión, enlace personal y de un solo uso). */
export function PublicApproval() {
  const { token } = useParams();
  const { data, error, loading } = useLoad(() => api.get(`/public/approval/${token}`), [token]);
  const { busy, run } = useAction();
  const [done, setDone] = useState<string | null>(null);
  const [reject, setReject] = useState(false);
  const [reason, setReason] = useState('');
  const [comment, setComment] = useState('');
  if (loading) return <Loading />;
  const inv = data?.invoice;
  return (
    <div className="auth-wrap">
      <div className="card stack" style={{ width: 'min(620px, 100%)' }}>
        <strong>Conforme · Aprobación de factura</strong>
        <ErrorBox error={error} />
        {done ? <div className="alert ok">{done}</div> : inv && (
          <>
            <h1>{inv.vendor_name}</h1>
            <p className="muted">{inv.company_name} · factura {inv.number ?? 's/n'} · {date(inv.issue_date)} · vence {date(inv.due_date)}</p>
            <div className="kpi"><span className="v">{eur(inv.total)}</span><span className="l">Importe total</span></div>
            {data.lines.length > 0 && <table><tbody>{data.lines.map((l: any, i: number) => <tr key={i}><td>{l.description}</td><td className="num">{l.quantity ?? ''}</td><td className="num">{eur(l.net_amount)}</td></tr>)}</tbody></table>}
            {inv.review_reasons?.length > 0 && <div className="alert warn">{inv.review_reasons.join(' · ')}</div>}
            <p className="hint">Para ver el documento original, entra en Conforme.</p>
            {!reject ? (
              <>
                <Field label="Comentario (opcional)"><textarea value={comment} onChange={(e) => setComment(e.target.value)} /></Field>
                <div className="row">
                  <button className="ok" disabled={busy} onClick={async () => { if (await run(() => api.post(`/public/approval/${token}`, { decision: 'approve', comment: comment || undefined }))) setDone('Factura aprobada. Gracias.'); }}>Aprobar</button>
                  <button className="danger" disabled={busy} onClick={() => setReject(true)}>Rechazar</button>
                </div>
              </>
            ) : (
              <>
                <Field label="Motivo del rechazo"><textarea value={reason} onChange={(e) => setReason(e.target.value)} autoFocus /></Field>
                <div className="row">
                  <button onClick={() => setReject(false)}>Volver</button>
                  <button className="danger" disabled={busy || reason.length < 3} onClick={async () => { if (await run(() => api.post(`/public/approval/${token}`, { decision: 'reject', reason }))) setDone('Factura rechazada. Se ha avisado al equipo.'); }}>Confirmar rechazo</button>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}

/** Página de estado para el proveedor. */
export function PublicStatus() {
  const { token } = useParams();
  const { data, error, loading } = useLoad(() => api.get(`/public/status/${token}`), [token]);
  if (loading) return <Loading />;
  return (
    <div className="auth-wrap">
      <div className="card stack" style={{ width: 'min(520px, 100%)' }}>
        <strong>Estado de su factura</strong>
        <ErrorBox error={error} />
        {data && (
          <>
            <h1>Factura {data.number}</h1>
            <p className="muted">Emitida el {date(data.issue_date)} a {data.company_name} · {data.totalLabel}</p>
            <div className="alert info"><strong>{data.statusLabel}</strong>{data.status === 'scheduled' && data.payment_date && <> · fecha prevista de pago {date(data.payment_date)}</>}{data.status === 'paid' && data.payment_date && <> el {date(data.payment_date)}</>}</div>
            {data.events?.length > 0 && <ul className="timeline">{data.events.map((e: any, i: number) => <li key={i}><span className="dot" /><div>{({ accepted: 'Aceptada', rejected: 'Rechazada', paid: 'Pagada', partially_paid: 'Pago parcial' } as any)[e.status]} · {date(e.date)}{e.reason && <div className="hint">Motivo: {e.reason}</div>}</div></li>)}</ul>}
          </>
        )}
      </div>
    </div>
  );
}
